import React from "react";
import AdFoxAdaptive from "../components/adfoxBlocks/AdFoxAdaptive";

export default function AdFoxTGB3_1({ context }) {

    return (
            <AdFoxAdaptive
                options={[
                    {
                        ownerId: 284551,
                        containerId: "adfox_157017151684022313212234",
                        params: {
                            pp: 'g',
                            ps: 'dmmq',
                            p2: 'hawr'
                        }
                    },
                    ["desktop", "tablet"],
                    {
                        tabletWidth: 830,
                        phoneWidth: 480,
                        isAutoReloads: false
                    }
                ]}
            />
    );
}
